<template>
    <div class="d-flex flex-xl-row flex-column">
        <Autocomplete
            :data="shipment.shipmentKind"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :label="__('Shipment')"
            :placeholder="__('Select shipment')"
            :scope="scope"
            :params="filterParameters"
            filterProperty="shipmentKind"
            :value="shipment.shipmentKind"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.shipmentKind!=null"
            name="receive_document_shipment"
            style="min-width:200px"
         
            v-validate="'required'"
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
                
            
            </div>
        </Autocomplete>

        <!-- <FormInput
            :label="__('Receive document')"
            :value="shipment.receiveDocument"
            class="p-0 mr-2 text-nowrap"
            disable-error-text
            name="receive_document"
            disabled
        /> -->

         <Autocomplete
            :data="shipment.receiveDocument"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :label="__('Receive document')"
            :placeholder="__('Receive document')"
            :scope="scope"
            :params="filterParameters"
            filterProperty="receiveDocument"
            :value="shipment.receiveDocument"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocument!=null"
            name="receive_document_shipment"
            style="min-width:100px"
            v-validate="'required'"
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
            
             
            </div>
        </Autocomplete>

           <Autocomplete
            :data="shipment.transport"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :label="__('Transport')"
            :placeholder="__('Transport')"
            :scope="scope"
            :params="filterParameters"
            filterProperty="transport"
            :value="shipment.transport"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocument!=null"
            name="receive_document_shipment"
            style="min-width:100px"
            v-validate="'required'"
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
            
             
            </div>
        </Autocomplete>

        <!-- <FormInput
            :label="__('Receive document date')"
            :value="shipment.receiveDocumentDate ? moment(shipment.receiveDocumentDate).format('YYYY-MM-DD') : shipment.receiveDocumentDate"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="receive_document_date"
        /> -->

         <Autocomplete
            :data="shipment.receiveDocumentDate? moment(shipment.receiveDocumentDate).format('YYYY-MM-DD') : shipment.receiveDocumentDate"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :params="filterParameters"
            :label="__('Receive document date')"
            :placeholder="__('Receive document date')"
            :scope="scope"
            filterProperty="receiveDocumentDate"
            :value="shipment.receiveDocumentDate"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocumentDate!=null"
            name="receive_document_shipment"
            style="min-width:120px"
            v-validate="'required'"
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
               
            
            </div>
        </Autocomplete>

        <!-- <FormInput
            :label="__('Size')"
            :value="shipment.shipmentSize"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="receive_document_size"
        /> -->
         <Autocomplete
            :data="shipment.shipmentSize"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :params="filterParameters"
            :label="__('Size')"
            filterProperty="shipmentSize"
            :placeholder="__('Size')"
            :scope="scope"
            :value="shipment.shipmentSize"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocumentDate!=null"
            name="receive_document_shipment"
            style="min-width:40px"
            v-validate="'required'"
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
               
            
            </div>
        </Autocomplete>

        <!-- <FormInput
            :label="__('Mark')"
            :value="shipment.marking"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="receive_document_marking"
        /> -->

         <Autocomplete
            :data="shipment.marking"
             :params="filterParameters"
            :data-vv-scope="scope"
            :fetch-callback="callbackType()"
            :label="__('Mark')"
            filterProperty="marking"
            :placeholder="__('Mark')"
            :scope="scope"
            :value="shipment.marking"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocumentDate!=null"
            name="receive_document_shipment"
            style="min-width:80px"
          
            value-selector="shipment.label"
        >
            <div slot-scope="result">
                {{ result.result.title }} <br>      
                <small><strong>{{ __('Size') }}:</strong> {{ result.result.shipmentSize}}</small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>
              
            
            </div>
        </Autocomplete>

        <!-- <FormInput
            :label="__('LotNo')"
            :value="shipment.lotNo"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="receive_document_lotNo"
        /> -->

         <Autocomplete
            :data="shipment.lotNo"
            :data-vv-scope="scope"
            :params="filterParameters"
            filterProperty="lotNo"
            :fetch-callback="callbackType()"
            :label="__('LotNo')"
            :placeholder="__('LotNo')"
            :scope="scope"
            :value="shipment.lotNo"
            @selected="selectShipment"
            class="p-0 mr-2"
            :disabled="shipment.receiveDocumentDate!=null"
            name="receive_document_shipment"
            style="min-width:80px"
           
            value-selector="shipment.label"
        >
            <div slot-scope="result">
             {{ result.result.title }} <br>
                <small><strong>{{ __('Size') }}:</strong> </small><br>        
                <small><strong>{{ __('Marking') }}:</strong> {{ result.result.marking}}</small><br>
                <small><strong>{{ __('LotNo') }}:</strong> {{ result.result.lotNo}}</small><br>
                <small><strong>{{ __('Receive document') }}:</strong> {{ result.result.receiveDocument}}</small><br>
                <small><strong>{{ __('Receive document date') }}:</strong> {{ moment(result.result.receiveDocumentDate).format('YYYY-MM-DD')}}</small><br>
                <small><strong>{{ __('Transport') }}:</strong> {{ result.result.transport}}</small><br>             
             
            </div>
        </Autocomplete>

        <FormInput
            :data-vv-scope="scope"
            :label="__('Quantity')"
            :scope="scope"
            class="p-0 mr-2 text-nowrap"
            min="0"
            name="receive_document_quantity"
            type="number"
            v-model="shipment.quantity"
            v-validate="{required: true, max_value: shipment.stockQuantity}"
            :max="50"
        />

        <FormInput
            :label="__('Balance')"
            :value="getBalance"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="receive_document_balance"
        />
      

          <FormInput
            :label="__('BRUTTO weight')"
            :value="getWeightBrutto"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="release_weight_brutto"
        />

        <FormInput
            :label="__('NETTO weight')"
            :value="getWeightNetto"
            class="p-0 mr-2 text-nowrap"
            disabled
            name="release_weight_netto"
        />

        <div class="text-nowrap form-group d-flex align-self-end ml-auto">
            <button
                @click.prevent="add()"
                class="btn btn-outline-secondary ml-2 btn-sm shipment-btn"
            >
                <font-awesome-icon class="fa-fw" icon="plus" size="1x"></font-awesome-icon>
            </button>

            <!-- <button
                @click.prevent="copy()"
                class="btn btn-outline-secondary ml-2 btn-sm shipment-btn"
            >
                <font-awesome-icon class="fa-fw" icon="copy" size="1x"></font-awesome-icon>
            </button> -->

            <button
                @click.prevent="remove()"
                class="btn btn-outline-secondary ml-2 btn-sm shipment-btn"
                v-if="canRemove"
            >
                <font-awesome-icon class="fa-fw" icon="trash-alt" size="1x"></font-awesome-icon>
            </button>
        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import ShipmentUnit from '../../models/ShipmentUnit'

export default {
  name: 'ShipmentTypeRow',

  inject: ['$validator'],

  data () {
    return {
      moment
    }
  },

  props: {
    filterParameters: {
      type: Array,
      default: []
      },
    index: { type: Number },
    load: { type: Object },
    canRemove: { type: Boolean },
    scope: { type: String },
    shipment: Object,
    shipmentType: String
  },

  computed: {
    getBalance () {
      return Math.round(this.shipment.stockQuantity - this.shipment.quantity)
    },
     getWeightBrutto () {
      return Math.round(this.shipment.quantity*this.shipment.unitWeightBrutto)
    },
    getWeightNetto () {
      return Math.round((this.shipment.quantity*this.shipment.unitWeightNetto) * 1000) / 1000
    }
  },

  methods: {
    callbackType () {
      if (this.shipmentType === 'release') {

        return this.$api.autocomplete.releaseDocumentsShipmentUnits
      } else if (this.shipmentType === 'shippingDocument') {
        return this.$api.autocomplete.shippingDocumentsShipmentUnits
      }
    },

    add () {
      this.$emit('add', new ShipmentUnit({}))
    },

    copy () {
      let shipment = new ShipmentUnit(_.cloneDeep(this.shipment))
      shipment.id = 0

      this.$emit('add', shipment)
    },

    remove () {
      this.$emit('remove', this.index)
    },

    canSelect () {
      return this.shipment!=null && this.shipment.shipmentKind!=null
    },
    selectShipment (shipment) {
      this.shipment.shipment = shipment.shipment
      _.merge(this.shipment, new ShipmentUnit(shipment))
    }
  }
}
</script>
